import * as Menu from '@radix-ui/react-dropdown-menu';
import { Link } from 'react-router-dom';
import type { Theme } from '../theme';

const APPEARANCE: [Theme, string][] = [
  ['system', 'Match device'],
  ['light', 'Light'],
  ['dark', 'Dark'],
];

/**
 * Who is signed in, with the things that belong to the account rather than the work:
 * appearance, Settings and Sign out. The contractor portal uses it without Settings, and
 * without Sign out while an office user is only viewing.
 */
export function AccountMenu(props: {
  name: string;
  theme: Theme;
  onTheme(t: Theme): void;
  onSignOut?: () => void;
  settings?: boolean;
  side?: 'top' | 'bottom';
}) {
  const initial = (props.name.trim()[0] ?? '?').toUpperCase();
  return (
    <Menu.Root>
      <Menu.Trigger className="account" aria-label={`Account menu for ${props.name}`}>
        <span className="account-initial" aria-hidden="true">
          {initial}
        </span>
        <span className="account-name">{props.name}</span>
        <svg viewBox="0 0 12 12" width="12" height="12" aria-hidden="true" focusable="false">
          <path
            d="M2.5 4.5 6 8l3.5-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Content
          className="account-menu"
          align="end"
          side={props.side ?? 'top'}
          sideOffset={6}
        >
          <Menu.Label className="account-label">Appearance</Menu.Label>
          <Menu.RadioGroup value={props.theme} onValueChange={(v) => props.onTheme(v as Theme)}>
            {APPEARANCE.map(([value, label]) => (
              <Menu.RadioItem key={value} value={value} className="account-radio">
                <Menu.ItemIndicator className="account-radio-check" aria-hidden="true" forceMount>
                  ✓
                </Menu.ItemIndicator>
                {label}
              </Menu.RadioItem>
            ))}
          </Menu.RadioGroup>
          {props.settings !== false && (
            <>
              <Menu.Separator className="account-sep" />
              <Menu.Item asChild>
                <Link to="/settings">Settings</Link>
              </Menu.Item>
            </>
          )}
          {props.onSignOut && (
            <>
              <Menu.Separator className="account-sep" />
              <Menu.Item onSelect={props.onSignOut}>Sign out</Menu.Item>
            </>
          )}
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
}
